import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';
import { TableFormat } from 'roosterjs-editor-types';
import { PredefinedTableStyles } from './tablesEnum/predefinedTableStylesEnum';
import { PREDEFINED_STYLES } from './predefinedStyles';

export function applyPredefinedStyles(editorId: string, predefinedStyle: PredefinedTableStyles) {
    const format = PREDEFINED_STYLES[predefinedStyle];
    executeTableFormat(editorId, format);
}

const executeTableFormat = (editorId: string, format: TableFormat) => {
    callEditorApi(editorId, 'focus');
    callFormatApi(editorId, 'formatTable', [format]);
};
